import { byKey, complex, simple } from '@mwl/marker-tree';

export const contactsPageSchema = complex({
  title: simple,
  faq: simple,
  contacts: byKey(simple),
});
